import React from 'react';
import ContactForm from "../../ContactForm/ContactForm";
import Banner from "../Banner/Banner";
import FeaturedCakes from "../Featured/FeaturedCakes/FeaturedCakes";
import FlavoredCakes from "../Featured/Flavors/FlavoredCakes/FlavoredCakes";
import Testimonials from "../Testimonials/Testimonials/Testimonials";
import WhyEatCake from "../WhyEatCake/WhyEatCake";

const Home = () => {
    return (
        <div>
            <Banner />
            <FlavoredCakes />
            <FeaturedCakes />
            <WhyEatCake />
            <Testimonials />
            <ContactForm />
        </div>
    );
};

export default Home;